import { Col, FormGroup, FormControl } from 'react-bootstrap';

const SubmissionSearchField = (props) => {
  const { outletCode, onOutletCodeChange } = props;

  return (
    <Col md={3}>
      <FormGroup>
        Search
        <FormControl
          value={outletCode}
          onChange={onOutletCodeChange}
          placeholder={'Enter Submission ID or outlet or rdr code'}
        >
        </FormControl>
      </FormGroup>
    </Col>
  );
};

export default SubmissionSearchField;
